import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea(props: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-md border border-border bg-surface px-4 py-3 text-base text-text shadow-xs transition-[color,box-shadow] outline-none placeholder:text-text-secondary/60 focus-visible:border-primary focus-visible:ring-[3px] focus-visible:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 md:text-sm",
        props.className
      )}
      {...props}
    />
  );
}

export { Textarea };
